import type {
  AdTag,
  FFWDAdEventType,
  VideoAdTag,
} from "@sunrise/backend-types";

export function isFFwdAdTag(tag: VideoAdTag): tag is AdTag<FFWDAdEventType> {
  return "fastforwardalternativevideoadstartevent" in tag.tracking;
}
